export const CHILD_SUPPORT_PAYMENT_CONTAINER_TAG_NAME = 'child-support-payment-container';
